module.exports = __webpack_public_path__ + "img/speakers-portatil.d4fc257d.png";